<!--
 * @Author: zhonghao
 * @Date: 2023-03-16 10:10:42
-->
<template>
  <div class="course-player">
    <video-player v-if="currentVideo.videoMaterial && currentVideo.videoMaterial.url" ref="video" class="video-player"
      @play="handlePlay" @timeupdate="handleTimeUpdate" :player-video="currentVideo" :video-list="videoList">
    </video-player>
    <transform-prompt-panel v-else></transform-prompt-panel>
    <CourseEvaluateWin :showCourseEvaluate.sync="showCourseEvaluate" :videoData="currentVideo"></CourseEvaluateWin>
  </div>
</template>

<script>
import TransformPromptPanel from './TransformPromptPanel.vue'
import CourseEvaluateWin from './CourseEvaluateWin.vue'
import VideoPlayer from './VideoPlayer.vue'
// import { hadnleUpdateVideo } from './common'

export default {
  name: 'CoursePlayer',
  components: {
    TransformPromptPanel,
    VideoPlayer,
    CourseEvaluateWin
  },
  props: {
    currentVideo: {
      type: Object
    },
    lastVideoId: {
      type: String
    },
    courseEvaluateList: {
      type: Object
    },
    videoList: {
      type: Array,
    }
  },
  data () {
    return {
      // 评价弹窗
      showCourseEvaluate: false,
      count: 0,
      curplayVideo: null
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    currentVideo (newVal) {
      if (this.curplayVideo && this.curplayVideo.id === newVal.id) return
      this.count = 0
      this.currentVideo = newVal
    }
  },
  mounted () {
  },
  methods: {
    handlePlay () {
    },
    handleTimeUpdate ({currentTime, playDuration, currentVideo}) {
      this.$emit('timeupdate', {
        currentTime,
      })
      this.curplayVideo = currentVideo
      // 播放时长
      const playbackProgress = (currentTime / currentVideo.videoMaterial.duration) >= (currentVideo.watchPassPercent / 100)
      // 累计时长
      const playDurationPro = ((Number(currentVideo.playDuration) + playDuration) / currentVideo.videoMaterial.duration) >= (currentVideo.watchPassPercent / 100)
      if (playbackProgress && playDurationPro && currentVideo.id === this.lastVideoId && Object.keys(this.courseEvaluateList).length <= 0 && this.count === 0) {
        this.showCourseEvaluate = true
        this.count++
      }
      if (playbackProgress && playDurationPro && currentVideo.learningStatus !== '1') {
        sessionStorage.setItem('curPlayVideoStatus', '1')
        // this.$refs.video.handleVideoTrace(currentVideo)
        // this.hadnleUpdateStatus(currentVideo)
      }
    },
    // hadnleUpdateStatus (currentVideo) {
    //   currentVideo.updateVideoStatus = '1'
    // hadnleUpdateVideo(currentVideo)
    // if (this.currentVideo.learningStatus === '1') return
    // const params = {
    //   iepUserId: this.userInfo.id,
    //   courseId: currentVideo.courseId,
    //   courseSectionId: currentVideo.id,
    //   learningStatus: '1'
    // }
    // postVideoRecords(params).then(() => {
    //   currentVideo.learningStatus = '1'
    // }).catch(() => {
    //   Toast('视频观看状态改变错误')
    // })
    // },
  }
}
</script>

<style lang="less" scoped>
.course-player {
  width: 100%;
  background: #000;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/CoursePlayer.vue